// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DetailTable-module_collapsible_card_m31xW {
  position: relative;
  min-width: 300px;
  padding-top: 16px !important;
  padding-bottom: 14px !important;
  transition: height 0.2s cubic-bezier(0.4, 1, 0.75, 0.9) !important;
}

.DetailTable-module_collapsible_card_m31xW:hover button {
  opacity: 1;
}

.DetailTable-module_collapsible_wrapper_dLxdq {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.DetailTable-module_collapsible_body_e9IYT {
  height: 100% !important;
  overflow-x: auto;
}

.DetailTable-module_collapsible_body_e9IYT > div {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.DetailTable-module_title_div_LE0tn {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;

  font-weight: 600;
  font-size: 16px;
  line-height: 19px;

  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom-color: var(--bp-light-gray1);
  border-bottom-width: thin;
  border-bottom-style: solid;
}

.DetailTable-module_left_title_div_FzYru {
  justify-content: left;
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.DetailTable-module_title_div_button_box_right_HpEnB {
  position: absolute;
  right: 50px;
}

.DetailTable-module_title_div_no_text_dcyes {
  display: flex;
  border: none;
}

.DetailTable-module_title_div_no_text_dcyes button {
  position: absolute;
  right: 6px;
  top: 6px;
}

.DetailTable-module_edit_view_button_OrJ5V {
  border-radius: 16px !important;
  opacity: 0.2;
}

.DetailTable-module_detail_cell_uurHo {
  vertical-align: middle;
  padding: 2px;
  max-width: 360px;
}

.DetailTable-module_detail_cell_uurHo textarea {
  min-width: 150px;
  padding: 4px !important;
}

.DetailTable-module_detail_cell_read_only_PfaY9 {
  padding: 6px;
}

.DetailTable-module_detail_cell_read_only_PfaY9 textarea:focus {
  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.15);
}

.DetailTable-module_detail_cell_read_only_compact_rsgcy {
  padding: 2px 6px;
}

.DetailTable-module_centered_detail_cell_vBthh {
  text-align: center;
  min-width: 30%;
}

.DetailTable-module_first_detail_cell_UIsip {
  padding: 6px;
  text-align: right;
  vertical-align: top;
  min-width: 30%;
}

.DetailTable-module_first_detail_cell_compact_RsGTQ {
  padding: 2px 6px;
}

.DetailTable-module_first_detail_cell_label_yAOdD {
  /* width: 50%; */
}

.DetailTable-module_disabled_B2UQj {
}

.DetailTable-module_alt_background_XHO4t {
  background-color: var(--bp-light-gray4) !important;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/DetailPanel/DetailTable.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,kEAAkE;AACpE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;;EAEnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EAEE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EAEE,YAAY;AACd;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EAGE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EACE,kDAAkD;AACpD","sourcesContent":[".collapsible_card {\n  position: relative;\n  min-width: 300px;\n  padding-top: 16px !important;\n  padding-bottom: 14px !important;\n  transition: height 0.2s cubic-bezier(0.4, 1, 0.75, 0.9) !important;\n}\n\n.collapsible_card:hover button {\n  opacity: 1;\n}\n\n.collapsible_wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n\n.collapsible_body {\n  height: 100% !important;\n  overflow-x: auto;\n}\n\n.collapsible_body > div {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.title_div {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom-color: var(--bp-light-gray1);\n  border-bottom-width: thin;\n  border-bottom-style: solid;\n}\n\n.left_title_div {\n  composes: title_div;\n  justify-content: left;\n  border-bottom: none;\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n\n.title_div_button_box_right {\n  position: absolute;\n  right: 50px;\n}\n\n.title_div_no_text {\n  display: flex;\n  border: none;\n}\n\n.title_div_no_text button {\n  position: absolute;\n  right: 6px;\n  top: 6px;\n}\n\n.edit_view_button {\n  composes: primary_button_minimal from 'Styles/styles.module.css';\n  border-radius: 16px !important;\n  opacity: 0.2;\n}\n\n.detail_cell {\n  vertical-align: middle;\n  padding: 2px;\n  max-width: 360px;\n}\n\n.detail_cell textarea {\n  min-width: 150px;\n  padding: 4px !important;\n}\n\n.detail_cell_read_only {\n  composes: detail_cell;\n  padding: 6px;\n}\n\n.detail_cell_read_only textarea:focus {\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.15);\n}\n\n.detail_cell_read_only_compact {\n  composes: detail_cell_read_only;\n  padding: 2px 6px;\n}\n\n.centered_detail_cell {\n  composes: detail_cell;\n  text-align: center;\n  min-width: 30%;\n}\n\n.first_detail_cell {\n  composes: bos_label from 'Styles/styles.module.css';\n  composes: detail_cell;\n  padding: 6px;\n  text-align: right;\n  vertical-align: top;\n  min-width: 30%;\n}\n\n.first_detail_cell_compact {\n  composes: first_detail_cell;\n  padding: 2px 6px;\n}\n\n.first_detail_cell_label {\n  composes: first_detail_cell;\n  /* width: 50%; */\n}\n\n.disabled {\n  composes: disabled from 'Styles/styles.module.css';\n}\n\n.alt_background {\n  background-color: var(--bp-light-gray4) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapsible_card": `DetailTable-module_collapsible_card_m31xW`,
	"collapsible_wrapper": `DetailTable-module_collapsible_wrapper_dLxdq`,
	"collapsible_body": `DetailTable-module_collapsible_body_e9IYT`,
	"title_div": `DetailTable-module_title_div_LE0tn`,
	"left_title_div": `DetailTable-module_left_title_div_FzYru DetailTable-module_title_div_LE0tn`,
	"title_div_button_box_right": `DetailTable-module_title_div_button_box_right_HpEnB`,
	"title_div_no_text": `DetailTable-module_title_div_no_text_dcyes`,
	"edit_view_button": `DetailTable-module_edit_view_button_OrJ5V ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_minimal"]}`,
	"detail_cell": `DetailTable-module_detail_cell_uurHo`,
	"detail_cell_read_only": `DetailTable-module_detail_cell_read_only_PfaY9 DetailTable-module_detail_cell_uurHo`,
	"detail_cell_read_only_compact": `DetailTable-module_detail_cell_read_only_compact_rsgcy DetailTable-module_detail_cell_read_only_PfaY9 DetailTable-module_detail_cell_uurHo`,
	"centered_detail_cell": `DetailTable-module_centered_detail_cell_vBthh DetailTable-module_detail_cell_uurHo`,
	"first_detail_cell": `DetailTable-module_first_detail_cell_UIsip ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_label"]} DetailTable-module_detail_cell_uurHo`,
	"first_detail_cell_compact": `DetailTable-module_first_detail_cell_compact_RsGTQ DetailTable-module_first_detail_cell_UIsip ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_label"]} DetailTable-module_detail_cell_uurHo`,
	"first_detail_cell_label": `DetailTable-module_first_detail_cell_label_yAOdD DetailTable-module_first_detail_cell_UIsip ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_label"]} DetailTable-module_detail_cell_uurHo`,
	"disabled": `DetailTable-module_disabled_B2UQj ${___CSS_LOADER_ICSS_IMPORT_0___.locals["disabled"]}`,
	"alt_background": `DetailTable-module_alt_background_XHO4t`
};
export default ___CSS_LOADER_EXPORT___;
